// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3ENkM","load6":"Spinner_load6__1L0HV","round":"Spinner_round__29p7P"};